export function getEventHasModifierKeys(event: any) {
    return event.shiftKey || event.altKey || event.ctrlKey || event.metaKey;
}
